import React, { useState } from "react";
import { ExternalLink, ChevronDown, ChevronUp, Radio } from "lucide-react";

export default function LiveSources({ sources }) {
  const [open, setOpen] = useState(false);
  if (!sources || sources.length === 0) return null;

  return (
    <div className="brutal-border bg-[color:var(--bg)] mb-6">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="sources-toggle"
        className="w-full flex items-center justify-between px-6 py-4 hover:bg-[color:var(--fg)] hover:text-[color:var(--bg)] transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="relative flex items-center justify-center w-2 h-2">
            <div className="absolute w-2 h-2 rounded-full bg-[color:var(--hot)] animate-ping opacity-75" />
            <div className="relative w-2 h-2 rounded-full bg-[color:var(--hot)]" />
          </div>
          <Radio size={14} />
          <span className="font-display text-lg uppercase tracking-tight">
            Live signals grounding these ideas
          </span>
          <span className="font-mono-tight text-xs opacity-60">
            {sources.length} sources · past 7d
          </span>
        </div>
        {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </button>

      {open && (
        <div className="border-t border-[color:var(--line)] p-6 grid grid-cols-1 md:grid-cols-2 gap-3">
          {sources.map((s, i) => (
            <a
              key={`${s.source}-${i}-${s.title.slice(0, 20)}`}
              href={s.url}
              target="_blank"
              rel="noreferrer noopener"
              data-testid="source-link"
              className="group flex items-start gap-3 p-3 border border-[color:var(--line)] hover:border-[color:var(--fg)] transition-colors"
            >
              <div className="tag flex-shrink-0 !py-1 !px-2 text-[9px]">{s.source}</div>
              <div className="flex-1 min-w-0">
                <div className="text-sm leading-snug line-clamp-2 group-hover:text-[color:var(--accent)] transition-colors">
                  {s.title}
                </div>
                <div className="text-[10px] font-mono-tight text-[color:var(--muted)] mt-1">
                  {s.score} pts
                </div>
              </div>
              <ExternalLink size={12} className="text-[color:var(--muted)] group-hover:text-[color:var(--fg)] flex-shrink-0 mt-1" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
